import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import AuditProcess from "@/components/site/AuditProcess";
import CompanyStats from "@/components/site/CompanyStats";
import LeadForm from "@/components/site/LeadForm";
import FooterCTA from "@/components/site/FooterCTA";
import Footer from "@/components/site/Footer";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

const Landing = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <AuditProcess />
      <CompanyStats />
      <LeadForm />
      <FooterCTA />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App font-sans" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/politique-de-confidentialite" element={<PrivacyPolicy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
